import { ReactNode } from 'react';
import { useMaintenanceStatus } from '@ygoargentina/sdk/api/appConfig';
import { MaintenanceScreen } from './maintenance-screen';

export function MaintenanceGate({ children }: { children: ReactNode }) {
  const { maintenance, title, message, endsAt } = useMaintenanceStatus();

  if (maintenance) {
    return (
      <MaintenanceScreen title={title} message={message} endsAt={endsAt} />
    );
  }

  return <>{children}</>;
}
